module.exports = __webpack_public_path__ + "static/12-e4ffcfa01fc2cb7645b6e5e6940126cc.jpg";